<template>
    <div id="data-list-thumb-view" class="data-list-container">

        <vs-prompt fullscreen blur @cancel="activePrompt =false" @accept="AddFromImdb" @close="activePrompt =false"
            :active.sync="activePrompt" accept-text="Add" title="Add Movie From IMDB">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Imdb ID" v-model="imdbId" />
            </div>
        </vs-prompt>

        <vs-prompt @cancel="val=''" blur @accept="pushNotify" @close="pushNotification=false" :active.sync="pushNotification"
            accept-text="Add" title="Push Notification">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Title"  v-model="notify.title" />
                <vs-textarea placeholder="Body" v-model="notify.body" />
            </div>
        </vs-prompt>

        <vs-table ref="table" search stripe sst="true" :data="$store.state.movies.movies.data" @change-page="fetchMovies"
            @search="handleSearch">

            <div slot="header" class=" ">

                <div class="flex flex-wrap-reverse items-center">

                    <!-- ADD NEW -->
                    <router-link to="/movies/create"
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                    </router-link>
                    <!-- <vs-button @click="activePrompt=true" class="p-3 mb-4 mr-4 rounded-lg ">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        Add By IMDB
                    </vs-button> -->


                </div>
                <div class="d-block text-left">

                    <vs-radio v-model="type" vs-value="0" color="dark" class="m-2">All</vs-radio>
                    <vs-radio v-model="type" vs-value="1" color="success" class="m-2">Movies</vs-radio>
                    <vs-radio v-model="type" vs-value="2" color="danger" class="m-2">Series</vs-radio>

                    <vs-pagination :total="$store.state.movies.movies.last_page" v-model="page"></vs-pagination>

                </div>


            </div>

            <template slot="thead">
                 <vs-th>Fatured</vs-th>
                <vs-th>Poster</vs-th>
                <vs-th sort-key="en_title">Name</vs-th>
                <vs-th sort-key="catgories">Category</vs-th>
                <vs-th sort-key="popularity">Status</vs-th>
                <vs-th sort-key="kind">Kind</vs-th>
                <vs-th sort-key="rating">Rating</vs-th>
                <vs-th sort-key="year">Year</vs-th>
                <vs-th sort-key="price">Views</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template>
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in $store.state.movies.movies.data" class="dark" >
                           <vs-td>
                        <vs-icon style="cursor: pointer;" v-if="tr.featured" icon="star" size="medium" color="warning" @click="featured_touch(tr)"></vs-icon>
                        <vs-icon style="cursor: pointer;"  v-if="!tr.featured" icon="star" size="medium"   @click="featured_touch(tr)"></vs-icon>
                        </vs-td>
                        <vs-td class="img-container">
                            <img :src="tr.poster" class="product-img" />
                        </vs-td>

                        <vs-td >
                            <p class="product-name font-medium truncate" v-if="tr.hidden ==0" @click="$router.push({name:'editMovie',params:{id:tr.id}})">{{ tr.en_title }}</p>
                            <p class="product-name font-medium truncate text-danger" v-else @click="$router.push({name:'editMovie',params:{id:tr.id}})">{{ tr.en_title }}</p>
                        </vs-td>

                        <vs-td>
                            <p class="product-category">{{ genres(tr.categories) }}</p>
                        </vs-td>

                        <vs-td>

                        </vs-td>

                        <vs-td>
                            <vs-chip v-if="tr.kind==1" color="green">
                                Movie
                            </vs-chip>
                            <vs-chip v-if="tr.kind==2" color="danger">
                                Series 
                            </vs-chip>
                        </vs-td>
                        <vs-td>
                            {{ tr.rating }}
                        </vs-td>
                        <vs-td>
                            {{ tr.year }}
                        </vs-td>

                        <vs-td>
                            <p>{{ tr.views }}</p>
                        </vs-td>

                        <vs-td class="whitespace-no-wrap">
                            <feather-icon v-if="tr.kind==2" title="Seasons & Episodes" @click="$router.push({name:'editMovie',params:{id:tr.id},query:{tab:'seasons'}})" icon="ListIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="mr-2" />
                            <feather-icon v-if="tr.hidden ==0" icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-2"
                                @click="visibility_toch(tr)" />
                            <feather-icon v-if="tr.hidden ==1" icon="EyeOffIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-2"
                                @click="visibility_toch(tr)" />
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="$router.push({name:'editMovie',params:{id:tr.id}})" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="delConfirm(tr)"/>
                         
                            <feather-icon title="push notify" @click="notificationDialog(tr)" icon="BellIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" />
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>

        </vs-table>
        <vs-pagination :total="$store.state.movies.movies.last_page" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                page: 1,
                type: 0,
                query: '',
                selected: [],
                activePrompt: false,
                pushNotification: false,
                // products: [],
                itemsPerPage: 4,
                isMounted: false,
                imdbId: '',
                notify:{
                    title:'',
                    body:'',
                    poster:true
                }

            }
        },
        watch: {
            page(val) {
                this.fetchMovies();
            },
            type(val) {
                this.fetchMovies();
            },
            query(val) {
                this.fetchMovies();
            },
            '$store.state.movies.loading': function () {

               // this.showLoading();
                this.$vs.loading.close()
            }

        },


        methods: {
            delConfirm(movie){
                this.selected=movie;
                 this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Delete Item`,
                    text: `Are you sure to delete this item (${movie.en_title})?`,
                    accept: this.del,
                    close: this.close
                })
            },
            del(){
                  this.axios.post(`${this.$apiUrl}/movies/delete/${this.selected.id}`).then(res => {
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Movie Deleted !',
                            text: res.data.response
                        })
                    }
                    this.fetchMovies();
                })
            },
            close() {
                this.selected=[];
            },
            notificationDialog(data){
                this.selected=[];
                this.notify.title=[];
                this.notify.body=[];
              this.pushNotification=true;
              this.selected=data;
               this.notify.title=data.ar_title;
                this.notify.body=data.ar_plot;
            },
              featured_touch(movie){
              this.axios.post(`${this.$apiUrl}/movies/${movie.id}/featured`).then(res => {
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Movie changed status  !',
                            text: res.data.response.en_name
                        })
                    }
                    this.fetchMovies();
                })
            },
            visibility_toch(movie){
              this.axios.post(`${this.$apiUrl}/movies/${movie.id}/visibility`).then(res => {
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Movie visibility changed   !',
                            text: res.data.response.en_name
                        })
                    }
                    this.fetchMovies();
                })
            },

               pushNotify() {
                this.$vs.loading()
                this.axios.post(`${this.$apiUrl}/notify`,{
                    'type':'movie',
                    'data':this.selected,
                    'options':this.notify
                }).then(res => {
                    this.$vs.loading.close()
                     if (res.status == 200) {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Notification Push',
                            text: ''
                        })
                    }
                }).catch(err=>{
                    this.$vs.loading.close()
                })
                // this.selected=[];
                // this.notify.title=[];
                // this.notify.body=[];
            },
            handleSearch(searching) {
                this.query = searching;
            },
            genres(genres) {
                var categories = [];
                genres.forEach(element => {
                    categories.push(element.en_name)
                });
                return categories.toString();
            },
            showLoading() {

                if (this.$store.state.movies.loading) {
                    console.log(this.$store.state.movies.loading);
                   // this.$vs.loading();
                } else {
                    this.$vs.loading.close();
                }
            },
            AddFromImdb() {
                this.$vs.loading()
                this.axios.post(`${this.$apiUrl}/movies/imdb/${this.imdbId}`).then(res => {
                    this.$vs.loading.close()
                    this.$router.push({
                        name: 'editMovie',
                        params: {
                            id: res.data.id
                        }
                    })
                })
            },
            
         
            fetchMovies() {
                var query = this.query;
                var type = this.type;
                var page = this.page;
                this.$vs.loading()
                this.$store.dispatch('movies/fetchMovies', {
                    page,
                    query,
                    type
                });
            }
        },
        created() {
            this.fetchMovies();

        },
        mounted() {
            this.isMounted = true
        },
        beforeRouteLeave(to, from, next) {
            // Close the add new item sidebar before leaving the route

            next()
        },
    }
</script>

<style lang="scss">
    #data-list-thumb-view {
        .vs-con-table {

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                >span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        &+i {
                            left: 1rem;
                        }

                        &:focus+i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;


                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 10px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }

                        &.img-container {
                            // width: 1rem;
                            // background: #fff;

                            span {
                                display: flex;
                                justify-content: flex-start;
                            }

                            .product-img {
                                height: 110px;
                            }
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>